import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (20 / 24);
  const localHeight = size * (19.673 / 24);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 20 19.673">
      <path
        d="M34.873,1090.194a.7.7,0,0,1-.153-.84l1.13-2.173a3.9,3.9,0,0,1-2.89-3.758v-4.389a3.893,3.893,0,0,1,3.889-3.888h.115v-.559a3.893,3.893,0,0,1,3.889-3.888h8.22a3.892,3.892,0,0,1,3.888,3.888v4.389a3.893,3.893,0,0,1-3.888,3.889h-.115v.558a3.893,3.893,0,0,1-3.889,3.888H40.113l-4.388,2.943a.7.7,0,0,1-.852-.059Zm-.52-11.161v4.389a2.5,2.5,0,0,0,2.5,2.5h.08a.7.7,0,0,1,.617,1.017l-.335.645,2.3-1.544a.7.7,0,0,1,.387-.118h5.167a2.5,2.5,0,0,0,2.5-2.5v-4.389a2.5,2.5,0,0,0-2.5-2.5H36.849A2.5,2.5,0,0,0,34.353,1079.033Zm4-4.447v.559h6.712a3.893,3.893,0,0,1,3.889,3.888v2.439h.115a2.5,2.5,0,0,0,2.5-2.5v-4.389a2.5,2.5,0,0,0-2.5-2.5h-8.22A2.5,2.5,0,0,0,38.357,1074.586Zm-1.273,8.885a.653.653,0,1,1,0-1.305H44.93a.653.653,0,1,1,0,1.305Zm0-2.811a.653.653,0,1,1,0-1.305H44.93a.653.653,0,1,1,0,1.305Z"
        transform="translate(-32.961 -1070.698)"
        fill={localColor}
      />
    </svg>
  );
};

export default Index;
